module.exports = __webpack_public_path__ + "static/media/new5@2x.422a414e.png";